"use client";
import { NavProvider } from "@/providers/Nav";
import { AnalyticsProvider } from "@/providers/Analytics";
import type { TopNavItem } from "@/lib/top-nav";
import type { ReactNode } from "react";

export default function Providers({
  children,
  topNavItems,
}: {
  children: ReactNode;
  topNavItems?: TopNavItem[];
}) {
  return (
    <NavProvider topNavItems={topNavItems}>
      <AnalyticsProvider>{children}</AnalyticsProvider>
    </NavProvider>
  );
}
